import { BrandingProvider } from './lib/branding'
import { Router } from './router'

export function App() {
  return (
    <BrandingProvider>
      <Router />
    </BrandingProvider>
  )
}
